<template>
  <div class="equip-message">
    <div class="message-container">
      <el-table class="talbe" :data="Data1" height="100%" style="width: 95%; background-color: #fcfcfc; color: #6EDDF1;"
        header-cell-style="background-color: #03044A; font-size: 15px ;color: #fff; textAlign: center"
        cell-style="background-color: #03044A; border:0;">
        <el-table-column prop="name" label="设备名称" align="center">
        </el-table-column>
        <el-table-column prop="cid" label="所在位置" align="center">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'EquipMessage',
    props: {
      pondsid: Number,
      companyId: Number,
      greenhouseId: Number
    },
    data() {
      return {
        Data1: [],
        timer: null // 定时器
      }
    },
    computed: {
      // messageContainerHei() {
      //   // 假设容器最多显示5条消息
      //   return this.messages.length * 40 + 100;
      // },
    },
    methods: {
      setData() {
                    const params = {};
                    // 优先使用 greenhouseId，如果没有则使用 pondsid（兼容旧参数）
                    if (this.greenhouseId) {
                        params.greenhouseId = this.greenhouseId;
                    } else if (this.pondsid) {
                        params.pondsid = this.pondsid;
                    }
                    if (this.companyId) {
                        params.companyId = this.companyId;
                    }
                    
                    this.request.get('/api/equipment/getpage1eq', {
                        params: params
                    })
                        .then(res => {                      
                            if (res.code === "200" && res.data && res.data.length > 0) {
                                this.Data1 = res.data;  // 将数据放入 Data1 中
                            } else {
                                // 如果请求失败或没有数据，清空列表
                                this.Data1 = [];
                            }
                        })
                        .catch(error => {
                            console.error('API 请求错误:', error);
                            // 请求失败时清空列表
                            this.Data1 = [];
                        });
                    },
      getRandomColor() {
        let letters = '0123456789ABCDEF';
        let color = '#';
        for (let i = 0; i < 6; i++) {
          color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
      },
    },
    watch: {
      pondsid() {
        this.setData();
        this.getRandomColor()
      },
      greenhouseId() {
        this.setData();
        this.getRandomColor()
      },
      companyId() {
        this.setData();
        this.getRandomColor()
      }
    },
    mounted() {
      // 移除 mounted 中的 setData，只依赖 watch 触发
      // 启动定时器，每30秒刷新一次传感器设备状态
      this.timer = setInterval(() => {
        // 只有当有有效数据时才刷新
        if (this.greenhouseId) {
          this.setData();
        }
      }, 30 * 1000); // 30秒
    },
    beforeDestroy() {
      // 组件销毁前清除定时器
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }
  }
</script>

<style lang="less">
  .equip-message {
    height: 95%;
    width: 100%;
    /* 你可以根据需要调整宽度 */
    overflow: hidden;
    position: relative;
    border: 0px solid #977575;


  }

  .message-container {
    margin: 5% 3%;
    width: 100%;
    /* 你可以根据需要调整宽度 */
    height: 86%;
    position: relative;
  }


  .dot1 {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    display: inline-block;
    margin: 0 auto;
    /* 水平居中 */
  }

  .green {
    background-color: green;
  }

  .red {
    background-color: red;
  }

  .orange {
    background-color: orange;
  }

  .gray {
    background-color: gray;
  }

  .el-table,
  .el-table th,
  .el-table td,
  .el-table tr {
    color: #fff;
    overflow: auto;
    border: 0.5px solid #1f507c !important;
    background-color: transparent !important;
  }

  .el-table--border::after,
  .el-table--group::after,
  .el-table::before {
    background-color: transparent !important;
  }

  /* 2.el-table滚动条样式 */
  /* 滚动条轨道宽度17会出现间隙，直接body撑满 */
  .el-table__body-wrapper,
  .el-table__body {
    /* 权重不够，需要增加important */
    width: 100% !important;
  }

  /* 滚动条大小设置  */
  .el-table__body-wrapper::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    border-radius: 10px;
    background-color: #1f507c !important;
  }

  /* 滚动条滑块样式设置 */
  .el-table__body-wrapper::-webkit-scrollbar-thumb {
    width: 10px;
    border-radius: 10px;
    background-color: rgb(161, 167, 170);
  }

  /* body宽度撑满后，表头会出现错位，增加下面样式覆盖gutter原始的宽度17 */
  .el-table__header colgroup col[name='gutter'],
  .el-table__body-wrapper colgroup col[name='gutter'] {
    display: table-cell;
  }

  .el-table th.gutter,
  colgroup.gutter {
    width: 10px !important;
    border-left: 1px solid transparent !important;
  }

  /* 隐藏表头最后一个单元格的右边框 */
  .has-gutter th.el-table__cell:nth-last-child(2) {
    /* 权重不够，需要增加important */
    border-right: none !important;
  }
</style>